import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaBanavim from './TablaBanavim';

const Banavim: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaBanavim />
  </Box>
);

export default Banavim;
